import type { IDownloadLog } from '$shared/interfaces/api/IDownloadLog';
import DateString from '$shared/models/DateString';
import EventLogExportType from '$shared/constants/EventLogExportType';
import JobStatus from '$shared/constants/JobStatus';

export default class DownloadLogs {
  public id: string;
  public type: EventLogExportType;
  public createdAt: DateString | null;
  public path: string;
  public fileSize: number | null;
  public eventCount: number | null;
  public status: JobStatus;

  constructor(response: IDownloadLog) {
    if (!response) {
      return;
    }
    this.id = response.id;
    this.type = response.type;
    this.createdAt = DateString.create(response.date);
    this.path = response.filePath;
    this.fileSize = response.fileSize;
    this.eventCount = response.eventCount;
    this.status = response.status;
  }
}
